export enum FavoriteGroupsActionEnum {
  SET_GROUPS = "SET_GROUPS",
  ADD_GROUP = "ADD_GROUP",
  REMOVE_GROUP = "REMOVE_GROUP",
  UPDATE_GROUP = "UPDATE_GROUP",
  SET_LOADING = "SET_LOADING",
}
